{
    "TeamsAuth_UserIntro": "Ciao {},",
    "TeamsAuth_UserIntro_2": "Akixi for MS Teams richiede l'accesso al vostro Microsoft Entra Tenant.",
    "TeamsAuth_AdminConsent": "Concessione del consenso amministrativo",
    "TeamsAuth_Authorise": "Autorizzare",
    "TeamsAuth_ConsentedMessage": "Consenso amministrativo accordato, fare clic su Autorizza per proseguire",
    "TeamsAuth_AuthorisedMessage": "Autorizzazione concessa",
    "TeamsAuth_Decline": "Declino",
    "TeamsAuth_Error_Unknown": "Si è verificato un errore non riconosciuto. Riprovare. Se il problema persiste, contattare l'amministratore di sistema.",
    "NAME": "TeamsAuth"
}